"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteNavSummaryLink = exports.Bar = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../atoms");
const Styled = styled_components_1.default.div `
	margin: 0 16px;
	height: 100%;

	.site-nav-link {
		position: relative;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;

		&:hover {
			color: ${(p) => p.theme.palette.text.primary};
			text-decoration: none;
		}

		&.disableIndicator {
			&::before {
				content: unset;
				display: hidden;
			}
		}

		&.defaultCursor {
			cursor: default;
		}

		&::before {
			background: ${(p) => p.theme.palette.accent.text};
			height: 0px;
			content: "";
			display: block;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 0;
			z-index: -1;
			opacity: 0;
			transition: height 0.2s ${(p) => p.theme.easing}, opacity 0.1s ${(p) => p.theme.easing} 0.15s;
		}
		&.mine,
		&.active,
		&:hover {
			&::before {
				height: 5px;
				opacity: 1;
				transition: height 0.2s ${(p) => p.theme.easing}, opacity ${(p) => p.theme.easing} 0.15s;
			}
		}
		&.other {
			&::before {
				height: 0;
				opacity: 0;
			}
		}
	}
`;
exports.Bar = styled_components_1.default.div `
	background-color: ${(p) => p.theme.palette.text.primary};
	height: 50%;
	margin: 0 16px;
	width: 1px;
`;
const SiteNavSummaryLink = ({ link = {}, activeLink, myMenuOpen, otherMenuOpen, disableIndicator, locale, }) => {
    let active = activeLink && link.key === activeLink.key;
    if (!link.key) {
        active = Boolean(activeLink === link);
    }
    const href = link.href || undefined;
    const isBar = link.isBarDivider;
    const onClick = (0, react_1.useCallback)((e) => {
        if (link.onClick && typeof link.onClick === "function") {
            link.onClick(e);
        }
        else if (!link.onClick && !href && !link.hrefTemplate) {
            e.preventDefault();
        }
    }, [href, link.onClick]);
    const onMouseDown = (0, react_1.useCallback)((e) => {
        if (link.onMouseDown && typeof link.onMouseDown === "function") {
            link.onMouseDown(e);
        }
        else if (!link.onMouseDown && !href) {
            e.preventDefault();
        }
    }, [href, link.onMouseDown]);
    if (isBar) {
        return react_1.default.createElement(exports.Bar, null);
    }
    const classes = (0, classnames_1.default)("site-nav-link", {
        mine: myMenuOpen,
        other: otherMenuOpen,
        disableIndicator,
        defaultCursor: !(href || link.hrefTemplate),
        active,
    });
    return (react_1.default.createElement(Styled, null,
        react_1.default.createElement(atoms_1.NavLink, { link: link, tabIndex: -1, className: classes, onClick: onClick, onMouseDown: onMouseDown, locale: locale, role: "menuitem" }, link.title)));
};
exports.SiteNavSummaryLink = SiteNavSummaryLink;
//# sourceMappingURL=SiteNavSummaryLink.js.map